"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteBillingCronResponse = exports.WaysteBillingCronRequest = exports.BillingDetailsSharedUpdateFields = exports.BillingDetailsSharedCreateFields = exports.BillingDetailsSharedQuery = exports.BillingDetailsSharedFields = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const collection_relation_update_1 = require("../../common/collection-relation-update");
const invoice_1 = require("../../invoice");
const enums_1 = require("../enums");
exports.BillingDetailsSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    startDate: typebox_1.Type.String({ format: 'date' }),
    endDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    billingUnit: enums_1.CommercialTermUnit,
    billingLength: typebox_1.Type.Integer({ minimum: 0 }),
    billingDay: typebox_1.Type.Integer({ minimum: 1 }),
    autopayEnabled: typebox_1.Type.Boolean(),
    autopayStripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopayProcessor: typebox_1.Type.Optional(invoice_1.AutopaySourceProcessorTransport),
    taxRate: typebox_1.Type.Number({ minimum: 0, maximum: 1 }),
    paymentTerm: typebox_1.Type.Integer({ minimum: 0 }),
    paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
    metadata: common_1.MetaData,
});
exports.BillingDetailsSharedQuery = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    subscriptionID: typebox_1.Type.String({ format: 'uuid' }),
    paymentTerm: typebox_1.Type.Integer({ minimum: 0 }),
    startsBefore: typebox_1.Type.String({ format: 'date' }),
    startsAfter: typebox_1.Type.String({ format: 'date' }),
    endsBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    endsAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
});
exports.BillingDetailsSharedCreateFields = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BillingDetailsSharedFields, ['id', 'haulerID', 'customerID', 'metadata']),
    typebox_1.Type.Object({
        lineItems: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })), // Will be replaced with CommercialLineItemNestedCreate
    }),
]);
exports.BillingDetailsSharedUpdateFields = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.BillingDetailsSharedFields, ['id', 'haulerID', 'customerID', 'metadata', 'paymentMethod']),
    typebox_1.Type.Object({
        lineItems: (0, collection_relation_update_1.CollectionRelationUpdate)(typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with CommercialLineItemNestedCreate
        typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with CommercialLineItemUpdate
        typebox_1.Type.String({ format: 'uuid' })),
        paymentMethod: (0, common_1.Nullable)(common_1.PaymentMethod),
        endDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date' })),
    }),
]));
exports.WaysteBillingCronRequest = typebox_1.Type.Optional(typebox_1.Type.Partial(typebox_1.Type.Object({
    billingIdsToProcess: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    date: typebox_1.Type.String({ format: 'date' }),
})));
exports.WaysteBillingCronResponse = typebox_1.Type.Object({
    billingActivityIdsCreated: typebox_1.Type.Array(typebox_1.Type.String()),
});
//# sourceMappingURL=billing-details-shared.js.map